import PropTypes from 'prop-types';
import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Badge,
} from '@mui/material';
import React, {useState, useEffect} from 'react';

import SearchBox from '../SearchBox/searchBox';
import filterComp from './filterComp.module.css';
import {ReactComponent as ExpandMoreIcon} from '../../assets/images/dropdown-down.svg';
import {ReactComponent as ExpandLessRoundedIcon} from '../../assets/images/dropdown-up.svg';
import {ReactComponent as CustomUncheckedIcon} from '../../assets/images/check-off.svg';
import {ReactComponent as CustomCheckedIcon} from '../../assets/images/check-on.svg';

const FilterComp = ({
  filterType,
  options,
  onFilterChange,
  filterSelected,
  buttonName,
  filterKey,
  filterName,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [checked, setChecked] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const open = Boolean(anchorEl);

  useEffect(() => {
    setChecked(filterSelected);
  }, [filterSelected]);

  const handleClose = () => {
    setAnchorEl(null);
    setMenuOpen(false);
    setSearchQuery('');
    if (filterType) {
      const tempArray = options
        .filter(data =>
          checked.includes(
            data[filterType === 'State' ? filterName : filterKey],
          ),
        )
        .map(option => option[filterType === 'State' ? filterName : filterKey]);
      setChecked(tempArray);

      onFilterChange(filterType, tempArray);
    }
  };

  const handleCheckboxChange = (event, optionVal) => {
    let {value} = event.target;
    if (filterType === 'Branch') {
      value = Number(value);
    }
    if (!value && optionVal) {
      value = optionVal;
    }
    const updatedChecked = checked.includes(value)
      ? checked.filter(item => item !== value)
      : [...checked, value];

    setChecked(updatedChecked);
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleSearchChange = event => {
    setSearchQuery(event.target.value);
  };

  // Filter the options based on the search query using stateName
  const filteredOptions = options.filter(
    option =>
      option[filterName] &&
      option[filterName]
        .toLowerCase()
        .includes(searchQuery.trim().toLowerCase()),
  );

  return (
    <Box>
      <Grid container onClick={handleClick} className={filterComp.filterButton}>
        <Grid item>
          <Box className={filterComp.insideButton}>
            <span className="text-bold-14px">{buttonName}</span>
            {!menuOpen && filterSelected.length > 0 && (
              <Badge
                badgeContent={filterSelected.length}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: '#F37021',
                    color: 'white !important',
                    fontSize: '10px',
                    minWidth: 'auto',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                }}
              />
            )}
          </Box>
        </Grid>
        <Grid item>
          <IconButton size="small">
            {menuOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
      </Grid>

      <Menu
        anchorEl={anchorEl}
        className={filterComp.menu}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            maxHeight: 'auto',
            width: 'auto',
            boxShadow: 'none',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '0px',
            marginTop: '8px',
          },
        }}>
        <Box className={filterComp.search}>
          <SearchBox
            searchQuery={searchQuery}
            handleSearch={handleSearchChange}
          />
        </Box>

        <Box className={filterComp.menuItem}>
          {filteredOptions.map((option, index) => (
            <MenuItem
              onClick={event =>
                handleCheckboxChange(
                  event,
                  option[filterType === 'State' ? filterName : filterKey],
                )
              }
              key={index}>
              <Grid container className={filterComp.menuItem_container}>
                <Grid item>
                  <Box className="text-medium-14px">{option[filterName]}</Box>
                </Grid>
                <Grid item>
                  <Checkbox
                    className={filterComp.menu_checkbox}
                    checked={checked.includes(
                      option[filterType === 'State' ? filterName : filterKey],
                    )}
                    onChange={handleCheckboxChange}
                    value={
                      option[filterType === 'State' ? filterName : filterKey]
                    }
                    icon={<CustomUncheckedIcon />}
                    checkedIcon={<CustomCheckedIcon />}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: '#96A6BE',
                      },
                      '&.Mui-checked .MuiSvgIcon-root': {
                        color: '#F37021',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </Box>
  );
};

FilterComp.propTypes = {
  filterType: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  filterKey: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      stateName: PropTypes.any,
      stateId: PropTypes.any,
    }),
  ).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default FilterComp;
